export default class NotificationController {
    constructor() {
        this.queue = [];

        this.messageShape = {
            message: "",
            timeout: 5000,
            buttonText: null,
            onClose: () => {},
            onClick: () => {},
        };
    }

    addNotification(message = {}) {
        const newMessage =
            typeof message === "string"
                ? Object.assign({}, this.messageShape, {
                      message: message,
                  })
                : Object.assign({}, this.messageShape, message);

        this.queue.push(newMessage);
    }

    hasNext() {
        return this.queue.length > 0;
    }

    getNext() {
        return this.queue.pop();
    }
}
